import "./auth.css";
import { GraduationCap, Lightning, Fire } from "@phosphor-icons/react";

export default function AuthLayout({
  children,
  title,
}: {
  children: React.ReactNode;
  title: React.ReactNode;
}) {
  return (
    <div className="min-h-screen w-full flex">
      {/* Left — login form */}
      <div className="flex-1 lg:w-1/2 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          {/* Logo (mobile only) */}
          <div className="flex justify-center mb-8 lg:hidden">
            <img
              src="/c2w_colorful_2.svg"
              alt="Code2Work"
              className="h-8 w-auto"
            />
          </div>

          {/* Card */}
          <div className="bg-surface-1 border border-white/[0.08] rounded-2xl overflow-hidden">
            <div className="px-8 pt-8 pb-4">
              <h1 className="text-xl font-bold">{title}</h1>
              <p className="text-sm text-white/35 mt-1">
                Hesabınla devam et
              </p>
            </div>
            <div className="px-8 pb-8">{children}</div>
          </div>

          {/* Footer (mobile only) */}
          <p className="text-center text-white/15 text-xs mt-6 lg:hidden">
            &copy; {new Date().getFullYear()} Code2Work
          </p>
        </div>
      </div>

      {/* Right — branding panel (desktop only) */}
      <div className="hidden lg:flex w-1/2 flex-col justify-center p-10 pr-16 relative overflow-hidden">
        {/* Background glow */}
        <div className="absolute inset-0 bg-gradient-to-bl from-myGreen/[0.06] via-transparent to-myBlue/[0.04]" />

        <div className="relative z-10 max-w-md mx-auto">
          <img
            src="/c2w_colorful_2.svg"
            alt="Code2Work"
            className="h-7 w-auto mb-8"
          />

          <h2 className="text-3xl font-bold leading-snug mb-4">
            Kodlama yolculuğunda
            <br />
            <span className="text-myGreen">bir adım önde</span> ol.
          </h2>
          <p className="text-white/40 text-base leading-relaxed">
            Pratik odaklı eğitimlerle gerçek dünya projelerine hazırlan.
            Canlı dersler, AI destekli değerlendirme ve gamification ile
            öğrenme deneyimini bir üst seviyeye taşı.
          </p>

          {/* Feature highlights */}
          <div className="mt-8 space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-myGreen/10 flex items-center justify-center shrink-0">
                <GraduationCap size={18} className="text-myGreen" weight="duotone" />
              </div>
              <div>
                <p className="text-sm font-medium">Pratik Odaklı Eğitim</p>
                <p className="text-xs text-white/30">Video dersler + interaktif alıştırmalar</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-myPurple/10 flex items-center justify-center shrink-0">
                <Lightning size={18} className="text-myPurple" weight="duotone" />
              </div>
              <div>
                <p className="text-sm font-medium">AI Değerlendirme</p>
                <p className="text-xs text-white/30">Anlık geri bildirim ile hızlı gelişim</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-myAmber/10 flex items-center justify-center shrink-0">
                <Fire size={18} className="text-myAmber" weight="duotone" />
              </div>
              <div>
                <p className="text-sm font-medium">Gamification</p>
                <p className="text-xs text-white/30">XP, seviye ve streak ile motivasyonunu koru</p>
              </div>
            </div>
          </div>

          <p className="text-white/15 text-xs mt-10">
            &copy; {new Date().getFullYear()} Code2Work
          </p>
        </div>
      </div>
    </div>
  );
}
